export default __webpack_public_path__ + "static/media/co-owner.c28f49ff.png";